<template>
  <icon-label
    :label="statusData.name"
    :icon="statusData.icon"
  />
</template>

<script>
import campaignStatuses from './campaign_statuses.js'
import iconLabel from '../../../components/IconLabel.vue'

export default {
  components: {
    'icon-label': iconLabel
  },
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    statusData () {
      return {
        name: this.$t(`campaignCpc.status.${this.status}`),
        icon: `${this.$publicPath}${campaignStatuses[this.status].icon}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
